import { cn } from "~/lib/utils";
import { Toggle } from "~/components/Toggle";

// // // //

interface Props {
    label: string;
    description?: string;
    checked: boolean;
    disabled?: boolean;
    onChange: (updatedValue: boolean) => void;
}

/**
 * ToggleRow
 * A boolean control laid out as a row: label (with optional description)
 * on the left and a switch on the right. The wrapping label makes the
 * entire row activate the switch.
 */
export function ToggleRow(props: Props) {
    const { label, description, checked, disabled = false, onChange } = props;

    return (
        <label
            className={cn("flex items-center justify-between gap-3", {
                "cursor-pointer": !disabled,
                "cursor-not-allowed": disabled,
            })}
        >
            <span
                className={cn("flex flex-col", {
                    "opacity-50": disabled,
                })}
            >
                <span className="text-sm text-foreground select-none">
                    {label}
                </span>
                {description && (
                    <span className="text-xs text-muted-foreground select-none">
                        {description}
                    </span>
                )}
            </span>

            {/* NOTE - we add `pointer-events-none` beacuse a <label> wrapping a button-based */}
            {/* switch would otherwise toggle twice on a direct click of the thumb. */}
            <span className="pointer-events-none">
                <Toggle
                    checked={checked}
                    size="md"
                    color="blue"
                    onChange={() => {
                        if (disabled) return;
                        onChange(!checked);
                    }}
                />
            </span>
        </label>
    );
}
